import Vue from 'vue'
import {
    Message,
    MessageBox,
    Container, Header, Main, Footer, Aside,
    Select,
    Option,
    Divider,
    Upload,
    Avatar,
    Image,
    Button,
    Form,
    FormItem,
    Input,
    Menu,
    MenuItem,
    Submenu,
    Table,
    TableColumn,
    Pagination,
    Row,
    Dialog,
    Popconfirm,
    OptionGroup,
    Checkbox,
    Progress,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Cascader,
    Loading,
    Radio,
    RadioGroup,
    RadioButton,
    Popover,
    Link,
    Backtop,
    Alert,
    Tabs,
    TabPane,
    Notification,
    Steps,
    Step,
    InfiniteScroll,
    Carousel,
    CarouselItem,
    CheckboxGroup,
    Empty,
    Tooltip,
    Scrollbar,
    Tag,
} from "element-ui";
Vue.use(Tag)
Vue.use(Tooltip)
Vue.use(Empty)
Vue.use(CheckboxGroup)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(InfiniteScroll)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Alert)
Vue.use(Backtop)
Vue.use(Popover)
Vue.use(Link)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Loading)
Vue.use(Cascader)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Progress)
Vue.use(Checkbox)
Vue.use(OptionGroup)
Vue.use(Popconfirm)
Vue.use(Dialog)
Vue.use(Row)
Vue.use(Pagination)
Vue.use(TableColumn)
Vue.use(Table)
Vue.use(Select)
Vue.use(Option)
Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(Container)
Vue.use(Header)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Aside)
Vue.use(Image)
Vue.use(Avatar)
Vue.use(Upload)
Vue.use(Divider)
Vue.use(Scrollbar)
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$notify = Notification
